import { PeriodBreadcrumbs } from '@/components/Navbar/PeriodBreadcrumbs';
import { QuarterNavigationForYear } from '@/components/Navbar/QuarterNavigationForYear';
import { WeekDayNavigation } from '@/components/Navbar/WeekDayNavigation';
import { WeekNavigationForQuarter } from '@/components/Navbar/WeekNavigationForQuarter';
import type { Period } from '@/entities/types';

interface PeriodPaneDisplayProps {
  title: string;
  subtitle: string;
  period: Period;
  periodStartAt: Date;
  className?: string;
  children: React.ReactNode;
}

export function PeriodPaneDisplay({
  title,
  subtitle,
  period,
  periodStartAt,
  className,
  children,
}: PeriodPaneDisplayProps) {
  return (
    <div className={`flex min-h-full flex-col ${className || ''}`}>
      <PeriodBreadcrumbs period={period} targetAt={periodStartAt} />
      <h1 className="text-2xl font-semibold">{title}</h1>
      <p
        className={`text-sm font-light text-gray-500 ${period === 'day' ? 'mb-4' : ''}`}
      >
        {subtitle}
      </p>
      {period !== 'day' && (
        <div className="mt-2 mb-4 flex items-center gap-4">
          {period === 'week' && (
            <WeekDayNavigation weekStartAt={periodStartAt} />
          )}
          {period === 'quarter' && (
            <WeekNavigationForQuarter quarterStartAt={periodStartAt} />
          )}
          {period === 'year' && (
            <QuarterNavigationForYear yearStartAt={periodStartAt} />
          )}
        </div>
      )}
      <hr className="mb-6 w-1/4 border-t-2 border-black" />
      {children}
    </div>
  );
}
